import React, { useState } from 'react';
import apiClient from '../../api/client';
import './IntegrationPopupWindow.css';

// Helper to get query params and provider name from URL
function useQuery() {
  return React.useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    // Extract provider name from URL path: /integration-popup-window/{providerName}
    const pathParts = window.location.pathname.split('/');
    const providerName = pathParts[pathParts.length - 1] || 'Integration';
    
    return {
      name: decodeURIComponent(providerName),
      status: params.get('status') || 'Active',
    };
  }, []);
}

const IntegrationPopupWindow = () => {
  const { name, status } = useQuery();
  const [isConnecting, setIsConnecting] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('');

  const handleConnect = async () => {
    setIsConnecting(true);
    setConnectionStatus('');

    try {
      const result = await apiClient.connectIntegration("Dropbox");

      console.log('Result:', result);
      
      if (result.status === 302 && result.redirectUrl) {
        // Navigate to the OAuth authorization page in the same popup window
        // Using replace() to avoid CORS preflight issues
        console.log('Redirecting to:', result.redirectUrl);
        window.location.replace(result.redirectUrl);
        return;
      }
      
      setConnectionStatus('Connected successfully!');
      console.log('Connection successful:', result);
    } catch (error) {
      setConnectionStatus('Connection failed. Please try again.');
      console.error('Connection error:', error);
    } finally {
      setIsConnecting(false);
    }
  };

  return (
    <div className="popup-container">
      <h1 className="popup-title">{name}</h1>
      <p className="popup-status">Status: {status}</p>
      <p className="popup-description">
        This is a detailed description for <b>{name}</b>. Here you can provide more information about the integration, its features, and how it connects to your system.
      </p>
      <button 
        className="popup-connect-button"
        onClick={handleConnect}
        disabled={isConnecting}
      >
        {isConnecting ? 'Connecting...' : 'Connect'}
      </button>
      {connectionStatus && (
        <p className="popup-status-message">{connectionStatus}</p>
      )}
    </div>
  );
};

export default IntegrationPopupWindow; 